import { render, staticRenderFns } from "./WaveCard.vue?vue&type=template&id=7486c3eb&"
import script from "./WaveCard.vue?vue&type=script&lang=js&"
export * from "./WaveCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports